const translations = {
  body: "My goal is to keep you from feeling overwhelmed during stressful situations. We'll figure this out together.",
  cta: "Schedule intro session",
  helper: "What to expect from your session",
  title: "Meet your Care Partner, {name}"
};

export default translations;
